import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';
import { NgIf } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { PIconModule } from '@panaya/ui/p-icon';
import { ThinkingState } from '@panaya/ai-chat/shared';

@Component({
    selector: 'ai-writing-indication',
    standalone: true,
    templateUrl: './writing-indication.component.html',
    styleUrls: ['./writing-indication.component.scss'],
    imports: [NgIf, TranslateModule, PIconModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class WritingIndicationComponent {
    @Input() state!: ThinkingState;
    @Input() translationKey!: string;
    @Input() translationParams?: Record<string, string>;
    /** Renders the indication as the next paragraph inside a message, instead of as a separate list item. */
    @HostBinding('class.inline')
    @Input()
    inline = false;
}
